import { render, staticRenderFns } from "./EditNews.vue?vue&type=template&id=6eb65401&scoped=true"
import script from "./EditNews.vue?vue&type=script&lang=js"
export * from "./EditNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb65401",
  null
  
)

export default component.exports